<template>
  <div>
    <modal
      name="modal-controlkm-detail"
      :width="`90%`"
      :height="`auto`"
      scrollable
      @opened="onModalOpened"
    >
      <v-card>
        <v-card-text class="text--primary pt-8">
          <v-row v-if="selected" class="text-center">
            <v-col cols="12" xs="12" sm="6">
              <h5>
                GPV: {{ `${selected?.user.name} ${selected?.user.surname}` }}
              </h5>
            </v-col>
            <v-col cols="12" xs="12" sm="6">
              <h5 class="text-left">
                Date:
                {{
                  selected?.date
                    ? moment(selected?.date).format("DD/MM/YYYY")
                    : ""
                }}
                <span v-if="selected?.user?.address">
                   &nbsp;| Dir Casa: &nbsp;{{ selected.user.address }}
                </span>
                <span v-else>
                  &nbsp;|&nbsp;No address available
                </span>
              </h5>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="6">
              <div ref="pos_google_map" class="pos_google_map"></div>
            </v-col>
            <v-col cols="12" xs="12" sm="12" md="6" v-if="isLoading">
              <b-alert show variant="info">
                <b-icon
                  icon="arrow-counterclockwise"
                  animation="spin-reverse"
                ></b-icon>
                cargando datos...
              </b-alert>
            </v-col>
            <v-col v-else cols="12" xs="12" sm="12" md="6">
              <h6 class="controlkm-detail-label">Resumen de la Jornada</h6>
              <table
                class="table b-table table-striped table-bordered table-sm b-table-stacked-sm m-0 controlkms-detail"
              >
                <tr>
                  <th class="stats-th">General</th>
                  <th class="stats-th">Dato</th>
                </tr>
                <!-- <template v-for="(detailItem, detailKey) in mainDetails">
                  <tr :key="`main_detail_${detailKey}`">
                    <td>{{ detailItem.label }}</td>
                    <td>{{ detailItem.value }}</td>
                  </tr>
                </template> -->
                <template v-for="(detailItem, detailKey) in mainDetails">
                  <tr
                    :key="`main_detail_${detailKey}`"
                    :style="
                      (detailItem.label === 'Inicio/Fin ruta ok' &&
                        detailItem.value === 'NO OK') ||
                      (detailItem.label === 'Motivo Inicio/Fin' &&
                        detailItem.value &&
                        detailItem.value.length > 0)
                        ? { background: '#add8e6' }
                        : {}
                    "
                  >
                    <td>{{ detailItem.label }}</td>
                    <td>{{ detailItem.value }}</td>
                  </tr>
                </template>
              </table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" lg="12" v-if="!isLoading">
              <h6 class="controlkm-detail-label">
                Detalle Clientes Visitados
              </h6>
              <table
                class="table b-table table-striped table-bordered table-sm b-table-stacked-sm m-0 controlkms-detail"
                v-if="
                  visitedPosList &&
                    visitedPosList.length > 0 &&
                    visitedPosTableList.length > 0
                "
              >
                <tr>
                  <th>Order of visit</th>
                  <th>Visit Type</th>
                  <th>Id POS / Id POS Brand</th>
                  <th>{{ $t("chain") }}</th>
                  <th>Full Address</th>
                  <th>HH:mm</th>
                  <th>Time In POS (HH:mm)</th>
                </tr>

                <tr
                  v-if="startLocation && startLocation.lat && startLocation.lng"
                >
                  <td>1</td>
                  <td>Start Route</td>
                  <td>-</td>
                  <td>
                    {{ startLocation?.startWrong ? "Fuera de Casa" : "Casa" }}
                  </td>
                  <td>
                    {{ startLocation.startAddress || "Unknown Start Address" }}
                  </td>
                  <td>
                    {{
                      startLocation.startTimeStamp
                        ? moment(startLocation.startTimeStamp).format("HH:mm")
                        : ""
                    }}
                  </td>
                  <td>
                    -
                  </td>
                </tr>

                <template v-for="(posItem, posKey) in visitedPosTableList">
                  <tr :key="`visted_pos_item_${posKey}`">
                    <td>{{ posItem.orderIndex + 1 }}</td>
                    <td>{{ posItem.visitTypeLabel }}</td>
                    <td>
                      {{ formatIdPosAndIdPosBrands(posItem) }}
                    </td>
                    <td>{{ posItem.po?.chain?.name ?? "" }}</td>
                    <td>{{ posItem.address_label }}</td>
                    <td>
                      {{
                        posItem.startTimeStamp
                          ? moment(posItem.startTimeStamp).format("HH:mm")
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        get_duration_hhmm(
                          posItem.startTimeStamp,
                          posItem.endTimeStamp
                        )
                      }}
                    </td>
                  </tr>
                </template>

                <tr v-if="endLocation && endLocation.lat && endLocation.lng">
                  <td>{{ visitedPosList.length + 2 }}</td>
                  <td>End Route</td>
                  <td>-</td>
                  <td>
                    {{ endLocation?.endWrong ? "Fuera de Casa" : "Casa" }}
                  </td>
                  <td>
                    {{ endLocation.endAddress || "Unknown Start Address" }}
                  </td>
                  <td>
                    {{
                      endLocation.endTimeStamp
                        ? moment(endLocation.endTimeStamp).format("HH:mm")
                        : ""
                    }}
                  </td>
                  <td>
                    -
                  </td>
                </tr>
              </table>

              <b-alert
                show
                variant="warning"
                v-else-if="visitedPosTableList.length === 0"
              >
                ¡Datos vacíos!...
              </b-alert>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click.stop="hideModal()">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </modal>
  </div>
</template>

<script>
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import _ from "lodash";
import moment from "moment";

export default {
  name: "DialogControlKMDetail",
  components: {},
  data: function() {
    return {
      isLoading: false,
      selected: null,
      mainDetails: [],
      visitedPosList: [],
      optimizedPosList: [],
      details_google_map: null,
      limitPosCountPerDirection: 22,
      markersList: []
    };
  },
  watch: {},
  computed: {
    visitedPosTableList() {
      let data = [];
      if (this.visitedPosList && this.visitedPosList.length > 0) {
        // data = this.visitedPosList.filter(el => el.po);
        data = this.visitedPosList.filter(el => true);
      }
      return data;
    },
    columns() {
      return [
        {
          text: `Total KM GPS`,
          value: "realTotalKMFormated",
          sortable: false,
          width: "200px"
        },
        {
          text: `TOTAL KM ${this.$t("Optimized")}`,
          value: "optimizedRealTotalKMFormated",
          sortable: false,
          width: "200px"
        },
        {
          text: `${this.$t("Difference")}`,
          value: "differenceFormated",
          sortable: false,
          width: "200px"
        },
        {
          text: `${this.$t("Final KM Started by GPV")}`,
          value: "finalKMByGPV",
          sortable: false,
          width: "200px"
        },
        {
          text: this.$t("comments"),
          value: "gpvComments",
          sortable: false,
          width: "200px"
        }
      ];
    }
  },
  methods: {
    async getLatLngFromPostalCode(postalCode, countryCode) {
      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode(
          {
            address: postalCode,
            componentRestrictions: {
              country: countryCode
            }
          },
          (results, status) => {
            if (status === "OK" && results[0]) {
              const location = results[0].geometry.location;
              const lat = location.lat();
              const lng = location.lng();
              resolve({ lat, lng });
            } else {
              resolve(null);
            }
          }
        );
      });
    },
    moment,
    showModal(selectedRow) {
      this.isLoading = true;
      this.selected = selectedRow;
      this.$modal.show("modal-controlkm-detail");
    },
    hideModal() {
      this.$modal.hide("modal-controlkm-detail");
    },
    onModalOpened() {
      this.initMap();
      this.init();
    },
    initMap() {
      var mapOptions = {
        // zoom: 14,
        // center: haight,
      };
      this.details_google_map = new window.google.maps.Map(
        this.$refs.pos_google_map,
        mapOptions
      );
    },
    renderDirections(result, color) {
      let renderOption = {};
      if (color) {
        renderOption.polylineOptions = { strokeColor: color };
      }
      var directionsRenderer = new window.google.maps.DirectionsRenderer({
        ...renderOption,
        suppressMarkers: true
      });
      directionsRenderer.setMap(this.details_google_map);
      directionsRenderer.setDirections(result);
    },
    requestDirections(pos_start, pos_end, waypoints, currentComponent, color) {
      const directionsService = new window.google.maps.DirectionsService();
      var request = {
        origin: pos_start,
        destination: pos_end,
        // Note that JavaScript allows us to access the constant
        // using square brackets and a string value as its
        // "property."
        travelMode: window.google.maps.TravelMode["DRIVING"]
      };
      if (waypoints.length > 0) {
        request.waypoints = waypoints;
      }
      directionsService.route(request, function(result) {
        currentComponent.renderDirections(result, color);
      });
    },
    formatKMs(km_value) {
      return !isNaN(km_value) && km_value !== null
        ? `${this.number_format_es(km_value / 1000)} KM`
        : "";
    },
    formatIdPosAndIdPosBrands(posItem) {
      let ret = posItem.posId;
      let idPosBrands = [];
      if (posItem?.po && posItem.po.posbrands.length > 0) {
        idPosBrands = posItem.po.posbrands.map(el => el.idPosBrand);
      }
      if (idPosBrands.length > 0) {
        ret += ` / ${idPosBrands.join(",")}`;
      }
      return ret;
    },
    async init() {
      this.mainDetails = [];
      if (this.selected && this.selected?.id) {
        const {
          user,
          realTotalKM,
          optimizedRealTotalKM,
          finalKMByGPV,
          gpvComments,
          worksessionKmApproverName,
          approvalKMstatus_label,
          finalKMByResponsable,
          expenseKilometer,
          kmgps,
          km_gps,
          difference,
          alert,
          approvalKMstatus,
          endWrongGPVComment,
          startWrongGPVComment
        } = this.selected;

        console.log("This selected: ", this.selected);

        console.log("Start Wrong GPV Comment: ", startWrongGPVComment);
        console.log("End Wrong GPV Comment: ", endWrongGPVComment);

        let pushItem = {};
        if (user) {
          pushItem.label = "GPV Ruta";
          pushItem.value = `${user.name} ${user.surname}`;
          this.mainDetails.push(pushItem);
        }
        this.mainDetails.push({
          label: `Tipo Liquidación`,
          value:
            user.liquidationType === "TOTAL_KM"
              ? "KM Totales"
              : user.liquidationType === "FIRST_CUSTOMER"
              ? "Desde 1º cliente"
              : ""
        });
        this.mainDetails.push({
          label: `KM Inicio`,
          value: `${this.number_format_es(
            expenseKilometer?.[0]?.startKM || ""
          )} KM`
        });
        this.mainDetails.push({
          label: `Final KM`,
          value: `${this.number_format_es(finalKMByResponsable)} KM`
        });
        this.mainDetails.push({
          label: `KM  Total`,
          value: `${this.number_format_es(
            finalKMByResponsable
              ? finalKMByResponsable - (expenseKilometer?.[0]?.startKM ?? 0)
              : expenseKilometer?.startKM ?? 0
          )} KM`
        });
        this.mainDetails.push({
          label: `Total KM GPS`,
          value:
            expenseKilometer && expenseKilometer.length
              ? expenseKilometer?.[0]?.expenseCalculations?.km_gps ?? 0
              : 0 ?? 0
        });
        // [Added by E2logy]: added KM GPS, Difference and Alert data
        // this.mainDetails.push({
        //   label: "KM GPS",
        //   value:
        //     expenseKilometer && expenseKilometer.length
        //       ? expenseKilometer?.[0]?.expenseCalculations?.km_gps ?? 0
        //       : 0 ?? 0
        // });
        this.mainDetails.push({
          label: "Difference",
          value:
            expenseKilometer && expenseKilometer.length
              ? expenseKilometer?.[0]?.expenseCalculations?.difference ?? 0
              : 0
        });
        this.mainDetails.push({
          label: "Alerta",
          value:
            expenseKilometer && expenseKilometer.length
              ? expenseKilometer?.[0]?.expenseCalculations?.alerta_km_gps ?? ""
              : ""
        });
        this.mainDetails.push({
          label: this.$t("status"),
          value: approvalKMstatus
        });
        this.mainDetails.push({
          label: `GPV ${this.$t("comments")}`,
          value: gpvComments
        });
        this.mainDetails.push({
          label: `Responsable`,
          value: user?.Parent
            ? user.Parent.name + " " + user.Parent.surname
            : ""
        });
        this.mainDetails.push({
          label: `Inicio/Fin ruta ok`,
          value:
            expenseKilometer &&
            expenseKilometer?.length &&
            expenseKilometer?.[0]?.expenseCalculations?.inicio_fin_route_ok
              ? expenseKilometer &&
                expenseKilometer?.length &&
                expenseKilometer?.[0]?.expenseCalculations?.inicio_fin_route_ok
              : ""
        });
        this.mainDetails.push({
          label: `Motivo Inicio/Fin`,
          value: (() => {
            let showComments = false;
            let startComment = "";
            let endComment = "";
            const inicio_fin_route_ok =
              expenseKilometer && expenseKilometer.length
                ? expenseKilometer?.[0]?.expenseCalculations
                    ?.inicio_fin_route_ok
                : null;

            console.log("Selected Item Here: ", this.selected);

            if (inicio_fin_route_ok && inicio_fin_route_ok === "NO OK") {
              if (
                !startWrongGPVComment.trim().length &&
                !endWrongGPVComment.trim().length
              ) {
                showComments = false;
              } else {
                showComments = true;
              }
            }

            if (
              showComments &&
              typeof startWrongGPVComment === "string" &&
              startWrongGPVComment.trim().length
            ) {
              startComment = startWrongGPVComment;
            } else {
              startComment = "Casa";
            }

            if (
              showComments &&
              typeof endWrongGPVComment === "string" &&
              endWrongGPVComment.trim().length
            ) {
              endComment = endWrongGPVComment;
            } else {
              endComment = "Casa";
            }

            return showComments
              ? `Inicio: ${startComment}\nFin: ${endComment}`
              : "";
          })()
        });

        try {
          let showCustomPoint = false;

          let customPoint = {
            lat: 0,
            lng: 0
          };

          let startedWrong =
            this.selected?.expenseKilometer &&
            this.selected?.expenseKilometer.length
              ? this.selected?.expenseKilometer[0]?.expenseCalculations
                  ?.inicio_fin_route_ok === "NO OK"
              : false;

          if (startedWrong) {
            showCustomPoint = true;
            customPoint = await this.getLatLngFromPostalCode(
              this.selected?.user?.address,
              "ES"
            );
          }
          console.log("customPoint:", customPoint);
          const {
            visitedPosList,
            // optimizedPosList,
            success,
            startLocation,
            endLocation
          } = await ApiService.get(
            `salesforce/controlkms/getdetail/${this.selected.id}`
          );

          if (success) {
            this.visitedPosList = visitedPosList;
            this.startLocation = startLocation ?? null;
            this.endLocation = endLocation ?? null;
            if (this.visitedPosList && this.visitedPosList.length > 0) {
              let posListLength = this.visitedPosList.length;
              let fullRoutePoints = []; // A temporary array to hold all points in order

              // 1. Add startLocation if available
              if (startLocation && startLocation.lat && startLocation.lng) {
                fullRoutePoints.push({
                  lat: startLocation.lat,
                  lng: startLocation.lng,
                  startAddress: startLocation.startAddress ?? null
                });
              }

              // 2. Add all visited POS
              fullRoutePoints = fullRoutePoints.concat(this.visitedPosList);

              // 3. Add endLocation if available and distinct from the last point
              if (endLocation && endLocation.lat && endLocation.lng) {
                const lastPointInFullRoute =
                  fullRoutePoints.length > 0
                    ? fullRoutePoints[fullRoutePoints.length - 1]
                    : null;

                if (
                  !lastPointInFullRoute ||
                  lastPointInFullRoute.lat !== endLocation.lat ||
                  lastPointInFullRoute.lng !== endLocation.lng
                ) {
                  fullRoutePoints.push({
                    lat: endLocation.lat,
                    lng: endLocation.lng,
                    endAddress: endLocation?.endAddress ?? null
                  });
                }
              }

              const infoWindow = new window.google.maps.InfoWindow();

              if (
                showCustomPoint &&
                customPoint &&
                customPoint.lat &&
                customPoint.lng
              ) {
                const customMarker = new window.google.maps.Marker({
                  position: { lat: customPoint?.lat, lng: customPoint?.lng },
                  map: this.details_google_map,
                  label: {
                    text: "C",
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                    border: "1px solid white"
                  },
                  icon: {
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: 18,
                    fillColor: "#47D45A",
                    fillOpacity: 1,
                    strokeWeight: 0,
                    outline: 1
                  }
                });

                customMarker.addListener("click", () => {
                  infoWindow.setContent(`
                                <div style="min-width:150px;">
                                    <strong>${this.selected?.user?.address ??
                                      "Unknown address"}</strong>
                                </div>
                            `);
                  infoWindow.open(this.details_google_map, customMarker);
                });

                this.markersList.push(customMarker);
              }

              fullRoutePoints.forEach((point, index) => {
                const marker = new window.google.maps.Marker({
                  position: { lat: point.lat, lng: point.lng },
                  map: this.details_google_map,
                  label: {
                    text: (index + 1).toString(),
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px"
                  }
                });

                // Attach click event to marker
                marker.addListener("click", () => {
                  const contentString = `
                  <div style="min-width:150px;">
                    <strong>Stop ${index + 1}</strong><br/>
                    ${point.address_label ||
                      point.startAddress ||
                      point.endAddress ||
                      "Unknown address"}
                  </div>
                 `;

                  infoWindow.setContent(contentString);
                  infoWindow.open(this.details_google_map, marker);
                });

                this.markersList.push(marker);
              });

              // Now, create drawList from fullRoutePoints
              let drawList = [];
              let directionIndex = 0;

              if (fullRoutePoints.length > 0) {
                // Only proceed if there are points to draw
                for (let i = 0; i < fullRoutePoints.length; i++) {
                  if (!drawList[directionIndex]) {
                    drawList[directionIndex] = [];
                  }
                  drawList[directionIndex].push(fullRoutePoints[i]);

                  // Segment creation logic:
                  // Create a new segment if current segment reaches limit
                  // AND it's not the very last point in the entire route
                  // AND there are more points to add
                  if (
                    drawList[directionIndex].length ===
                      this.limitPosCountPerDirection &&
                    i < fullRoutePoints.length - 1
                  ) {
                    directionIndex++;
                  }
                }
              }

              for (let i = 0; i < drawList.length; i++) {
                let segment = drawList[i]; // Get the current segment (which is an array)
                let drawListItemLength = segment.length;

                if (drawListItemLength < 2) {
                  // A segment must have at least a start and an end point.
                  // This might happen if limitPosCountPerDirection is 1 and you have an odd number of total points.
                  // Or if you only have one total point.
                  console.warn(
                    "Skipping map segment with less than 2 points:",
                    segment
                  );
                  continue;
                }

                let pos_start = segment[0];
                let pos_end = segment[drawListItemLength - 1];

                let startPoint = new window.google.maps.LatLng(
                  pos_start.lat,
                  pos_start.lng
                );
                let endPoint = new window.google.maps.LatLng(
                  pos_end.lat,
                  pos_end.lng
                );

                let waypoints = [];
                if (drawListItemLength > 2) {
                  for (let j = 1; j < drawListItemLength - 1; j++) {
                    let posItem = segment[j];
                    let posItemPoint = new window.google.maps.LatLng(
                      posItem.lat,
                      posItem.lng
                    );
                    waypoints.push({ location: posItemPoint });
                  }
                }
                this.requestDirections(
                  startPoint,
                  endPoint,
                  waypoints,
                  this,
                  null
                );
              }
            }
            // let optimizedPosList = [];
            // this.visitedPosList.map((el, index) => {
            //   let optimized_item = { ...el };
            //   if (
            //     (el?.po &&
            //       el?.worksession_po &&
            //       el.worksession_po.visitType === "PRESENT") ||
            //     index === 0 ||
            //     index === this.visitedPosList.length
            //   ) {
            //     optimizedPosList.push(optimized_item);
            //   }
            // });
            // this.optimizedPosList = optimizedPosList;
            // if (this.optimizedPosList && this.optimizedPosList.length > 0) {
            //   let posListLength = this.optimizedPosList.length;
            //   let pos_start = this.optimizedPosList[0];
            //   let pos_end = this.optimizedPosList[posListLength - 1];
            //   let startPoint = new window.google.maps.LatLng(
            //     pos_start.lat,
            //     pos_start.lng
            //   );
            //   let endPoint = new window.google.maps.LatLng(
            //     pos_end.lat,
            //     pos_end.lng
            //   );
            //   let waypoints = [];
            //   if (posListLength > 2) {
            //     for (let i = 1; i < posListLength - 1; i++) {
            //       let posItem = this.optimizedPosList[i];
            //       let posItemPoint = new window.google.maps.LatLng(
            //         posItem.lat,
            //         posItem.lng
            //       );
            //       waypoints.push({ location: posItemPoint });
            //     }
            //   }
            //   this.requestDirections(
            //     startPoint,
            //     endPoint,
            //     waypoints,
            //     this,
            //     "#00ff00"
            //   );
            // }
          }
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
        }
      } else {
        logError("Network error !");
      }
    }
  },
  async updated() {},
  async mounted() {}
};
</script>

<style>
.controlkms-detail tr th {
  background: #203864;
  color: #fff;
}
.controlkms-detail tr th,
.controlkms-detail tr td {
  vertical-align: middle;
}
h6.controlkm-detail-label {
  background: #b4c7e7;
  padding: 0.5rem 0.5rem;
  border-radius: 10px;
  font-size: 1.2rem;
  text-align: center;
}
.pos_google_map {
  width: 100%;
  height: 60vh;
}
</style>
